var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kldn-contacts"},_vm._l((_vm.contacts),function(c){return _c('div',{key:c.text+c.link,staticClass:"kldn-contacts__contact"},[_c('Link',{attrs:{"href":c.link,"target":'_blank'}},[_vm._v("\n    "+_vm._s(c.text)+"\n    ")])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6116a1cc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contacts/index.vue
// module id = null
// module chunks = 